// src/pages/HomePage.js
import React from 'react';
import '../styles/pages/HomePage.css';
import Header from '../components/home/Header';
import HeroSection from '../components/home/HeroSection';
import PatientBenefitsSection from '../components/home/PatientBenefitsSection';
import HowItWorksSection from '../components/home/HowItWorksSection';
import SyncProblemsSection from '../components/home/SyncProblemsSection';
import ComparisonSection from '../components/home/ComparisonSection';
import PricingSection from '../components/home/PricingSection';
import PlannedAppointmentsSection from '../components/home/PlannedAppointmentsSection';
import FinalCTASection from '../components/home/FinalCTASection';
import Footer from '../components/home/Footer';

const HomePage = () => {
  return (
    <div className="home-page">
      <Header mode="home" />
      <HeroSection />
      <PatientBenefitsSection />
      <HowItWorksSection />
      <SyncProblemsSection />
      <ComparisonSection />
      <PricingSection />
      <PlannedAppointmentsSection />
      <FinalCTASection />
      <Footer />
    </div>
  );
};

export default HomePage;